module.exports = __webpack_public_path__ + "static/media/studyDetailBackground.fbe7cd6b.png";